<template lang="pug">
table.tech-map-tab-table.issues-table
  thead
    tr
      th
        span.column-header-title Исполнитель
      th
        span.column-header-title Начало (план)
      th
        span.column-header-title № недели
      th
        span.column-header-title Статус
      th
        span.column-header-title Подпись
  tbody
    tr(v-for="tab in tabs")
      td(v-for="row in tab.rows") 
        span {{ row.value || "–" }}
</template>

<script setup>
// Возможно надо сносить. Данный компонент может быть отображен только если в компоненте floor_point переменная active будет true
// Функция назначающая переменную active true была закомментирована 3 года назад и соответственно этот компонент не может быть отображен
import { computed, onMounted } from "vue";

const props = defineProps({
  /**
   * Дата от родителя. Пример:
    {
      "tabs": ""
    }
   */
  parentData: {
    type: Object,
    default: () => ({}),
  },
});

const tabs = computed(() => props.parentData.tabs ?? []);

onMounted(() => {
  console.log(tabs);
});
</script>

<style lang="scss"></style>
